import { useStyleConfigV2 } from '@tectonic/elemason-components';

import type { ElemasonIframeWidget } from '@tectonic/types';
import { isHaloScript } from '@tectonic/utils';
import type { FC } from 'react';
import { useHaloScript } from '../../hooks/useHaloScript';

interface ElemasonIframeWidgetProps {
  widget: ElemasonIframeWidget;
}

const IframeWidget: FC<ElemasonIframeWidgetProps> = ({
  widget: { data, config },
}) => {
  const isScript = isHaloScript(data?.src);
  const url = useHaloScript((isScript ? data?.src : undefined) as any);

  const [style, className] = useStyleConfigV2(config);

  return (
    <iframe
      src={(isScript ? url : data?.src) as any}
      title={data?.title}
      style={style}
      className={className}
    />
  );
};

export { IframeWidget };
